export default __webpack_public_path__ + "img/course-appetizer.png";